import { Checkbox } from "@progress/kendo-react-inputs";

export const IsDetailProperty = {
  propertyName: "IsDetail",
  propertyDisplay: "Is Detail?",
  propertyType: "boolean",
  propertyCategory: "Validation",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Checkbox
        name={this.propertyName}
        disabled={currentPropertyValues?.IsEditable}
        title={
          currentPropertyValues?.IsEditable
            ? "Cannot be selected while Is Editable in Grid is True"
            : ""
        }
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
          handlePropertyChange({ propName: "IsEditable", propValue: false });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || false}
      />
    );
  },
};
